import AbsComponent from '../../common/components/AbsComponent';
import templ from './NctvTempl';

/**
 * Nctv class
 * @category mainApp
 */
class Nctv extends AbsComponent{
	constructor(_store = {}, _el = '') {
		super(_store, _el);
		this.store.getNctvData('Nctv', {}, this.render.bind(this));
	}

	render(_jsonData = {} ) {
		this.data = _jsonData;

		if (!this.data.NctvTitle.showArea) {
			$(this.el).hide();
			return false;
		}

		$(this.el).append(templ.getTempl(_jsonData ,  this.store.data.config.nctvDomain ));

		this.setting();
		this.addEvents();
	}

	setting(){
		$('#cardTypeNctv').slick({
			dots: false,
			arrows: false,
			infinite: true,
			autoplay: true,
			autoplaySpeed: 4000,
			speed: 300,
			slidesToShow: 2,
			slidesToScroll: 1,
			responsive: [
				/*{
					breakpoint: 3800,
					settings: "unslick"
				},*/
				{
					breakpoint: 3800,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						dots: false
					}
				},
				{
					breakpoint: 959,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true
					}
				}
			]
		});

		$(window).on('resize orientationchange', function() {
			$('#cardTypeNctv').slick('resize');
		});
	}

	addEvents(){
	}
}

export default Nctv;